import axios from 'axios'
import { ENCERRAR_MDFE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function encerrarMdfe(emissaoMdfeId, empresaId) {
  const url = `${URL}/evento-mdfe/${emissaoMdfeId}/empresa/${empresaId}/encerrar`;
  return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: ENCERRAR_MDFE,
        payload: response
      })
  );
}
